<form [formGroup]="sampleGroupForm">

  <!-- Toolbar -->
  <div class="flex items-center gap-2.5 py-3.5 px-7 flex-wrap">
    <!-- Search -->
    <div class="relative">
      <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
      <input type="text" placeholder="Search groups..." (keyup)="searchGroups($event.target.value)"
        class="search-input py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)]">
    </div>

    <!-- New Group -->
    <button (click)="addNewGroup()"
      class="py-2 px-3.5 bg-[var(--primary-dark)] text-white rounded-lg text-xs font-semibold cursor-pointer border-none flex items-center gap-1.5">
      <span class="material-icons text-[16px]">add</span> New Group
    </button>

    <!-- Merge -->
    <button (click)="openMergeWithDialog()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">merge_type</span> Merge With
    </button>

    <!-- Clear Filters -->
    <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
    </button>

    <!-- Pin Type Filter -->
    <!-- Pin Type Filter -->
    <div class="relative" #pinTypeDropdown>
      <div (click)="showPinTypeMenu = !showPinTypeMenu; $event.stopPropagation()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <img *ngIf="pinType?.id" [src]="'../../assets/icons/' + pinIcons[pinType.id]" class="w-4 h-4" alt="">
        <span *ngIf="!pinType?.id" class="material-icons text-[16px]">filter_list</span>
        <span>{{pinType?.name || 'All Pin Types'}}</span>
        <span class="material-icons text-[16px]">expand_more</span>
      </div>
      <div *ngIf="showPinTypeMenu"
        class="absolute top-[calc(100%+4px)] left-0 min-w-[200px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
        <div *ngFor="let pt of pinTypesList"
          (click)="selectPinType(pt)"
          class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)] flex items-center gap-2"
          [class.font-semibold]="pt === pinType">
          <img *ngIf="pt?.id" [src]="'../../assets/icons/' + pinIcons[pt.id]" class="w-4 h-4" alt="">
          <span *ngIf="!pt?.id" class="material-icons text-[16px]">filter_list</span>
          <span>{{pt.name}}</span>
        </div>
      </div>
    </div>

    <div class="flex-1"></div>

    <!-- Date Range -->
    <div class="flex gap-2.5 mr-6">
      <app-custom-datepicker label="START DATE" [value]="filterStartDate" (valueChange)="filterStartDate=$event; filterDateRange()"></app-custom-datepicker>
      <app-custom-datepicker label="END DATE" [value]="filterEndDate" (valueChange)="filterEndDate=$event; filterDateRange()"></app-custom-datepicker>
    </div>
  </div>

  <!-- Table -->
  <div class="px-7 overflow-y-auto" [ngStyle]="{'height': tableHeight}">
    <table mat-table [dataSource]="dataSource.data" class="w-full border-collapse">

      <ng-container matColumnDef="table-checkboxes">
        <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">
          <input type="checkbox" (change)="toggleAllSelection($event)" [checked]="isGroupItemSelected"
            class="w-4 h-4 accent-[var(--primary-dark)] cursor-pointer" (click)="$event.stopPropagation()">
        </th>
        <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">
          <input type="checkbox" (change)="onGroupSelectedChecked($event,element.id)" [checked]="selectedToMerge.includes(element.id)"
            class="w-4 h-4 accent-[var(--primary-dark)] cursor-pointer" (click)="$event.stopPropagation()">
        </td>
      </ng-container>

      <ng-container matColumnDef="table-groupName">
        <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Group Name</th>
        <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.name ?? placeholder}}</td>
      </ng-container>

      <ng-container matColumnDef="table-pinType">
        <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Pin Type</th>
        <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element.pinType ? element.pinType : placeholder}}</td>
      </ng-container>

      <ng-container matColumnDef="table-sample-count">
        <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Sample Count</th>
        <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element.sampleCount ? element.sampleCount : placeholder}}</td>
      </ng-container>

      <ng-container matColumnDef="table-dateCreated">
        <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Date Created</th>
        <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element.dateCreated ? dayjs(element.dateCreated).format(dateStringFormatting) : placeholder}}</td>
      </ng-container>

      <ng-container matColumnDef="table-created-by">
        <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Created By</th>
        <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element.user.userName ? element.user.userName : placeholder}}</td>
      </ng-container>

      <ng-container matColumnDef="table-actions">
        <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !bg-[var(--app-base)] !border-b !border-[var(--app-base)]"></th>
        <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !border-b !border-[var(--app-base)]">
          <span class="material-icons text-[18px] text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--primary-dark)]" (click)="viewSampleGroup(element.id,element.name)">chevron_right</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" style="height: auto; min-height: unset"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="cursor-pointer transition-colors !h-auto"
        style="height: auto; min-height: unset"
        (click)="viewSampleGroup(row.id, row.name)"></tr>
    </table>

    <div *ngIf="isNoItemsFound" [ngStyle]="{'height': tableHeight}" class="flex items-center justify-center text-[var(--tertiary-text)] text-[13px]">
      Sorry! No items found within the selected filter range.
    </div>
  </div>

  <!-- Paginator -->
  <div class="flex items-center justify-end py-3.5 px-7 gap-4 border-t border-[var(--app-base)]">
    <span class="text-[12px] text-[var(--tertiary-text)] font-medium">Items per page:</span>
    <div class="relative" #pageSizeDropdown>
      <div (click)="showPageSizeMenu = !showPageSizeMenu; $event.stopPropagation()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span>{{pageSize}}</span>
        <span class="material-icons text-[16px]">expand_more</span>
      </div>
      <div *ngIf="showPageSizeMenu"
        class="absolute bottom-[calc(100%+4px)] left-0 min-w-[80px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
        <div *ngFor="let size of [5, 10, 25, 100]"
          (click)="pageSize = size; showPageSizeMenu = false; onPageSizeChange()"
          class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
          [class.font-semibold]="size === pageSize">
          {{size}}
        </div>
      </div>
    </div>
    <span class="text-[13px] text-[var(--base-text-alt-dark)] font-medium">{{currentPage * pageSize + 1}} – {{min((currentPage + 1) * pageSize, totalElements)}} of {{totalElements}}</span>
    <div class="flex gap-1">
      <button (click)="goToPage(0)" [disabled]="currentPage === 0"
        class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
        <span class="material-icons text-[16px]">first_page</span>
      </button>
      <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
        class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
        <span class="material-icons text-[16px]">chevron_left</span>
      </button>
      <button (click)="goToPage(currentPage + 1)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
        class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
        <span class="material-icons text-[16px]">chevron_right</span>
      </button>
      <button (click)="goToPage(lastPage)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
        class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
        <span class="material-icons text-[16px]">last_page</span>
      </button>
    </div>
  </div>

  <!-- Floating Delete Button (bottom-left) -->
  <div *ngIf="selectedToMerge.length > 0" class="fixed bottom-5 left-24 z-[100]">
    <button (click)="openDeleteGroupsDialog()"
      class="py-2.5 px-5 bg-[var(--notification-error)] text-white border-none rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-2 shadow-[0_4px_12px_rgba(179,38,30,0.3)] hover:opacity-90 transition-all">
      <span class="material-icons text-[18px]">delete</span> DELETE
    </button>
  </div>

</form>
